import { Dialog } from '@headlessui/react';
import React, { useState } from 'react'
import Slider from 'react-slick';
import { projects } from '../../PersonaliseLessons/utilities/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const ProjectPerk = () => {

    const [modalEnabled , setModalEnabled] = useState({is_show : false , project: {project_thumbnail : "" ,title: "" ,description : "" , }});
    const settings = {
        dots: false,
        slidesToShow: 2,
        rows: 1,
        speed: 300,
        cssEase: "linear",
        infinite: false,
        dots: false,
        arrows: false,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                slidesToShow: 2,
                infinite: false,
                dots: false,
                arrows: false,
                swipeToSlide: true,
                },
            },
        ],
      };
  return (
    <div className='mt-3'>
        <Slider {...settings}>
        {projects?.length > 0 &&
            projects?.map((item, index) => (
            <div key={index} className="relative text-white flex flex-col mr-2 justify-center items-center">
                <div className='w-full rounded-lg flex flex-col justify-center items-center px-1'>
                    <div className='w-full flex flex-col  rounded-lg items-center relative bg-[#4F769D]'>
                        <div className='w-full h-auto'>
                            <img src={item?.['project_thumbnail']} alt='' className='w-full h-full rounded-t-lg'/>
                        </div>
                        <div className='w-full px-1 md:px-3'>
                            <div className='text-xs md:text-sm overflow-y-scroll h-[50px] md:h-[55px] mt-2 font-bold inline-block  text-ellipsis overflow-hidden'>{item?.title}</div>
                            {/* <div className='h-20 md:h-24 w-full overflow-y-scroll  text-xs font-medium ' dangerouslySetInnerHTML={{ '__html': item?.description }}/> */}
                        </div>
                        <div className='w-4/5 pb-2 md:pb-4'>
                            <button className='bg-[#13B284] w-full rounded-lg text-white py-1.5 md:py-3 text-sm mt-2' onClick={(e)=> setModalEnabled((prev)=> ({...prev,is_show : true,project : item }))}>View Project</button>
                        </div>
                    </div>
                </div>
            </div>
        ))}
        </Slider>
      {
        modalEnabled?.is_show &&   <Dialog open={modalEnabled?.is_show} onClose={() => {
          setModalEnabled((prev)=> ({...prev , is_show : false}));
      }}
          as="div"
          style={{ zIndex: '9999999999' }}
          className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start justify-center flex-col items-center">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
          <Dialog.Title />
          <Dialog.Description />
          <div className='relative bg-[#2D4F71] text-white z-10 overflow-y-auto md:w-[500px] my-auto h-4/5 lg:h-[90%] w-5/6 rounded-xl flex flex-col justify-start  items-center py-4  md:p-4  shadow-2xl'>
          <div className='w-full flex flex-col justify-center items-center rounded-lg px-2 '>
                <div className='text-xl mt-2 font-bold inline-block text-ellipsis text-center overflow-hidden leading-6'>{modalEnabled?.project?.title}</div>
                <img src={modalEnabled?.project?.['project_thumbnail']} className='w-full mt-2  rounded-lg'></img>
                <div className='flex flex-row self-start justify-center items-center rounded-xl my-4 px-3 py-2 bg-[#528CC6]'>
                    <img src={modalEnabled?.project?.domain_icon} className='w-6 mr-1'></img>
                    <div className='text-sm ml-1 ' style={{
                        fontFamily: 'Montserrat'
                    }}>{modalEnabled?.project?.domain}</div>
                </div>
                <div className='w-full flex flex-col' style={{
                    fontFamily: 'Montserrat'
                }}>
                    <div className='text-[#00C1FF] self-start font-semibold'>About this Project</div>
                    <div className='w-full mt-1 border-[1px]'/>
                    <div className='h-auto mt-2 w-full overflow-y-scroll text-sm text-start' dangerouslySetInnerHTML={{ '__html': modalEnabled?.project?.description }}/>
                </div>
                <div className='w-full flex flex-col mt-2' style={{
                    fontFamily: 'Montserrat'
                }}>
                    <div className=' mt-4 font-semibold text-[#00C1FF] self-start '>Skills Showcase</div>
                    <div className='w-full mt-1 border-[1px]'/>
                    <div className='w-full mt-2'>
                      {
                        modalEnabled?.project?.['skills_showcase']?.map((item)=> <div className='text-start text-sm'>{item}</div>)
                      }
                    </div>
                </div>
                <div className='w-full flex flex-col mt-2' style={{
                    fontFamily: 'Montserrat'
                }}>
                    <div className='text-md mt-4 font-medium text-[#00C1FF] self-start '>Tools Used</div>
                    <div className='w-full mt-1 border-[1px]'/>
                    <div className='w-full mt-4 flex flex-wrap justify-between items-center'>
                      {
                        modalEnabled?.project?.['tools_showcase']?.map((item)=> <img className='w-20 h-auto my-1 mb-3  mx-1 md:mx-2 md:my-2 md:w-24' src={item}/>)
                      }
                    </div>
                </div>
                <div className='w-full flex flex-col mt-2' style={{
                    fontFamily: 'Montserrat'
                }}>
                    <div className='text-md mt-4 font-medium text-[#00C1FF] self-start '>Companies Who Loved This Project</div>
                    <div className='w-full mt-1 border-[1px]'/>
                    <div className='w-full mt-4 flex flex-wrap justify-between items-center'>
                      {
                        modalEnabled?.project?.['companies_showcase']?.map((item)=> <img className='w-20 my-1 mx-1 md:mx-2 md:my-2 mb-3 md:w-24 ' src={item}/>)
                      }
                    </div>
                </div>
                </div>
                <div className='flex flex-row justify-center items-center self-end my-6 font-bold mr-2'>
                  <FontAwesomeIcon icon={faDownload} size="sm" className='bg-[#4ABC96] rounded-full px-2 py-2 text-white mr-1'/>
                  <div className='text-sm md:text-md text-[#00C1FF] ml-1 cursor-pointer' style={{
                        fontFamily: 'Montserrat'
                  }} onClick={(e)=>window.open(modalEnabled?.project?.['download_link'],'_blank')}>Download Project</div>
                </div>
            </div>
      </Dialog>
      }
    </div>
  )
}

export default ProjectPerk
